// extracted by extract-css-chunks-webpack-plugin
module.exports = {"brand":"BrandsIndexContainer-ab476c6e88929e0f"};